module.exports = __webpack_public_path__ + "static/media/activities.cd76822e.png";